<template>
  <div class="area page-component">
    <div class="container">
      <h1 class="text-left container-sm">{{ title }}</h1>
      <p class="lead-text text-left container-sm">{{ $prismic.richTextAsPlain(lead) }}</p>
      <div class="area__map-wrapper">
        <div class="area__map-container" id="js-area">
          <img src="/images/area/area-kriens-map.jpg" alt="Area of Kriens" />
          <div class="area__item-container">
            <div class="area__item-svg-routes" id="svgContainer">
              <!--<img src="/images/area/area-svg-routes.svg" />-->
              <simple-svg
                src="/images/area/area-svg-routes.svg"
                width="100%"
                height="100%"
              />
            </div>
            <div class="area__item area__item--kriens" v-view.once="startAnimation"></div>
            <div class="area__item area__item--rigi state-hidden" data-destination="rigi"></div>
            <div class="area__item area__item--luzern state-hidden" data-destination="luzern"></div>
            <div class="area__item area__item--entlebuch state-hidden" data-destination="entlebuch"></div>
            <div class="area__item area__item--pilatus state-hidden" data-destination="pilatus"></div>
            <div class="area__item area__item--burgerstock state-hidden" data-destination="burgerstock"></div>
            <div class="area__item area__item--stanserhorn state-hidden" data-destination="stanserhorn"></div>
            <div class="area__item area__item--engelberg state-hidden" data-destination="engelberg"></div>
          </div>
        </div>

        <div class="area__map-description">
          <a class="area__map-description-item state-hidden" data-destination="rigi">
            <span class="chip chip--borderless">{{ fields.rigi.distance}}</span>
            <h3>{{ fields.rigi.title }}</h3>
          </a>
          <a class="area__map-description-item state-hidden" data-destination="luzern">
            <span class="chip chip--borderless">{{ fields.lucerne.distance}}</span>
            <h3>{{ fields.lucerne.title }}</h3>
          </a>
          <a class="area__map-description-item state-hidden" data-destination="entlebuch">
            <span class="chip chip--borderless">{{ fields.entlebuch.distance}}</span>
            <h3>{{ fields.entlebuch.title }}</h3>
          </a>
          <a class="area__map-description-item state-hidden" data-destination="pilatus">
            <span class="chip chip--borderless">{{ fields.pilatus.distance}}</span>
            <h3>{{ fields.pilatus.title }}</h3>
          </a>
          <a class="area__map-description-item state-hidden" data-destination="burgerstock">
            <span class="chip chip--borderless">{{ fields.burgerstock.distance}}</span>
            <h3>{{ fields.burgerstock.title }}</h3>
          </a>
          <a class="area__map-description-item state-hidden" data-destination="stanserhorn">
            <span class="chip chip--borderless">{{ fields.stanserhorn.distance}}</span>
            <h3>{{ fields.stanserhorn.title }}</h3>
          </a>
          <a class="area__map-description-item state-hidden" data-destination="engelberg">
            <span class="chip chip--borderless">{{ fields.engelberg.distance}}</span>
            <h3>{{ fields.engelberg.title }}</h3>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SVG } from '@svgdotjs/svg.js'
import EventBus from '../EventBus'

export default {
  name: 'Area',
  props: ['title', 'lead'],
  data: function () {
    return {
      fields: {
        rigi: {
          distance: null,
          title: null
        },
        lucerne: {
          distance: null,
          title: null
        },
        entlebuch: {
          distance: null,
          title: null
        },
        pilatus: {
          distance: null,
          title: null
        },
        burgerstock: {
          distance: null,
          title: null
        },
        stanserhorn: {
          distance: null,
          title: null
        },
        engelberg: {
          distance: null,
          title: null
        }
      },
      svgPathList: [],
      animationTimes: {
        pathReveal: 2500,
        mapItemReveal: 1500
      }
    }
  },
  mounted () {
    let thisRef = this

    $(".area__item, .area__map-description-item").on('mouseenter', function () {
      let destinationId = $(this).attr('data-destination')
      thisRef.highlightDestination(destinationId)
    })

    $(".area__item, .area__map-description-item").on('mouseleave', function () {
      let destinationId = $(this).attr('data-destination')
      thisRef.deHighlightDestination(destinationId)
    })

    this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
  methods: {
    async getContent (language) {
      let document = await this.$prismic.client.getSingle('area', {lang: language})
      if (document) {
        this.fields.rigi.distance = document.data.rigidistance
        this.fields.rigi.title = document.data.titlerigi
        this.fields.lucerne.distance = document.data.lucernedistance
        this.fields.lucerne.title = document.data.titlelucerne
        this.fields.entlebuch.distance = document.data.entlebuchdistance
        this.fields.entlebuch.title = document.data.titleentlebuch
        this.fields.pilatus.distance = document.data.pilatusdistance
        this.fields.pilatus.title = document.data.titlepilatus
        this.fields.burgerstock.distance = document.data.burgerstockdistance
        this.fields.burgerstock.title = document.data.titleburgerstock
        this.fields.stanserhorn.distance = document.data.stanserhorndistance
        this.fields.stanserhorn.title = document.data.titlestanserhorn
        this.fields.engelberg.distance = document.data.engelbergdistance
        this.fields.engelberg.title = document.data.titleengelberg
      }
    },
    async startAnimation () {
      
      await this.sleep(1000)

      let thisRef = this
      $('.area__item').each( async function () {
        thisRef.showAreaItem($(this))
      })
      thisRef = null

      this.svgPathList.push(SVG('path#luzern'))
      this.svgPathList.push(SVG('path#rigi'))
      this.svgPathList.push(SVG('path#pilatus'))
      this.svgPathList.push(SVG('path#burgerstock'))
      this.svgPathList.push(SVG('path#engelberg'))
      this.svgPathList.push(SVG('path#stanserhorn'))
      this.svgPathList.push(SVG('path#entlebuch'))

      for (let path of this.svgPathList) {
        this.revealSVGPath(path)
      }

      await this.sleep(this.animationTimes.mapItemReveal)

      let mapDescriptionItems = document.getElementsByClassName('area__map-description-item')
      for (let item of mapDescriptionItems) {
        await this.sleep(100)
        item.classList.remove('state-hidden')
      }

    },
    async showAreaItem (element) {
      await this.sleep(Math.random() * this.animationTimes.mapItemReveal)
      element.removeClass('state-hidden')
    },
    revealSVGPath (path) {
      let length = path.node.getTotalLength()
      path.stroke({width: '4', color: '#ff6786', dasharray: length, dashoffset: -length})
      path.animate(this.animationTimes.pathReveal, '>', 0).stroke({dashoffset: 0})
    },
    async showMapDescriptionItem (element) {
      element.removeClass('state-hidden')
      await sleep(100)
    },
    highlightDestination (destinationId) {
      $('#' + destinationId).addClass('state-hover')
      $('.area__map-description-item[data-destination="' + destinationId + '"]').addClass('state-hover')
      $('.area__item[data-destination="' + destinationId + '"]').addClass('state-hover')
    },
    deHighlightDestination (destinationId) {
      $('#' + destinationId).removeClass('state-hover')
      $('.area__map-description-item[data-destination="' + destinationId + '"]').removeClass('state-hover')
      $('.area__item[data-destination="' + destinationId + '"]').removeClass('state-hover')
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time))
    }
  }
}
</script>